import { menuEditorSelectors } from "features/editor/editorSlice";
import { EditorItem } from "features/editor/editorUtils";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { equals } from "ramda";
import { LabelDocument, LabelItem } from "./LabelDocumentModel";
import { labelEditorActions, labelEditorSelectors } from "./labelEditorSlice";
import { LabelDocumentRenderer, PreviewRenderProps } from "./LabelRenderer";


export interface LabelPreviewItemProps {
    labelItem: EditorItem<LabelItem>;
    isPreview?: boolean;
}

export function LabelPreviewItem(props: LabelPreviewItemProps) {
    const dispatch = useAppDispatch();
    const document = useAppSelector(menuEditorSelectors.document) as LabelDocument;

    const labelEditorItemKey = useAppSelector(labelEditorSelectors.itemKey);
    const activeNodeId = useAppSelector(labelEditorSelectors.activeNodeId);
    const isPageActive = equals(props.labelItem.itemKey, labelEditorItemKey);

    // DevInit uncomment to edit template live
    /* props = clone(props);
    props.labelItem.menuItem.templateData = applyVariation(
        templates[1].templateData,
        templates[1].variations[3],
        templates[1].variations[3]
    ) */

    const renderer = new LabelDocumentRenderer(document, props.labelItem.menuItem);

    const renderProps: PreviewRenderProps = props.isPreview?{
        active: isPageActive,
        onNodeClick: nodeId => {
            dispatch(labelEditorActions.activateNodeById(nodeId))
        },
        activeNodeId: activeNodeId||undefined
    }:{};
    const renderedTemplate = renderer.renderTemplate(renderProps);

    if (!document) return null;

    const template = document.template;
    return <article className={`overflow-hidden relative select-none`}
        style={{
            "width": template.size.width+"mm",
            "height": (template.size.height-0.25)+"mm"
        } as any}
    >
        {renderedTemplate}
    </article>
}
